import { UPI_FIELD_META, UPI_FIELD_ORDER } from "../../constants/payment";
import { getPaymentOptionSlug } from "../shared/paymentOptions";

export function findUpiOption(options) {
  if (!Array.isArray(options)) return null;
  return options.find((option) => getPaymentOptionSlug(option) === "upi") || null;
}

export function parseUpiLink(upiLink) {
  const query = String(upiLink || "").split("?")[1] || "";
  return Object.fromEntries(new URLSearchParams(query));
}

export function getUpiParamsFromOption(option) {
  const raw = option?.details?.link;
  if (!raw || !String(raw).toLowerCase().startsWith("upi:")) {
    return null;
  }
  return parseUpiLink(raw);
}

export function buildManualTransferItems(upiParams, fieldTranslations, t) {
  if (!upiParams) {
    return [];
  }

  const items = [];

  for (const key of UPI_FIELD_ORDER) {
    const value = (upiParams[key] || "").trim();
    const meta = UPI_FIELD_META[key];

    if (!value && !(meta && meta.required)) {
      continue;
    }

    const label = fieldTranslations[key] || key;
    const suffix = meta?.required ? ` (${t("required")}):` : ":";

    items.push({
      key,
      label: `${label}${suffix}`,
      value: value || "—",
      rawValue: value,
      highlighted: key === "pa",
    });
  }

  for (const [key, value] of Object.entries(upiParams)) {
    if (UPI_FIELD_META[key]) {
      continue;
    }

    const trimmedValue = (value || "").trim();
    if (!trimmedValue) continue;

    items.push({
      key: `extra-${key}`,
      label: `${key}:`,
      value: trimmedValue,
      rawValue: trimmedValue,
      highlighted: false,
    });
  }

  return items;
}
